import axios from 'axios'

const CustomerMemoService = {
  /**
   * Retrieve data based on the provided parameters
   * @async
   * @param {Object} params - Query parameters to filter data
   * @param {number} params.page - Name of the cluster to search for
   * @param {number} params.per_page - Number of data per page
   * @param {string} params.sort - Sort by field (e.g., 'name', 'created_at')
   * @param {boolean} params.sort_desc - Sorting if descending (e.g., 'true' or 'false')
   * @param {string} params.filter_text - Text to filter data by name
   * @returns {Promise<Object>} The API response containing data
   */
  async get (params = {}) {
    return axios.get('fso/customer-memos', { params })
  },

  async show (id) {
    return axios.get(`fso/customer-memos/${id}`)
  },

  async post (params = {}) {
    return axios.post('fso/customer-memos', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`fso/customer-memos/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`fso/customer-memos/${data.id}`, { data })
  }
}

export default CustomerMemoService
